import React from 'react';
import { RESOURCE_LIST } from '@/constants/resources';
import { Emphasize } from '@/components/ui/PageTemplate';
import DownloadSvg from './DownloadSvg';

const ResourceList = () => {
  return (
    <div className='w-full flex flex-col items-center gap-3 md:gap-0 border-t border-b border-white mt-3'>
      {RESOURCE_LIST.map((resource, index) => {
        return (
          <div
            key={`resource${index}`}
            className='w-full flex items-center gap-4 hover:bg-[#FCCB1633] cursor-pointer transition-colors duration-200 px-4 py-2 group border-b border-[#6C6C6C]'
          >
            <div className='flex-1 min-w-0 flex flex-col gap-1'>
              <div className='text-sm xl:text-lg font-bold text-white flex-1 items-baseline min-w-0 truncate'>
                <span>{index + 1}.&nbsp;</span>
                {resource.title.split('$').map((part, idx) => {
                  return (
                    <React.Fragment key={idx}>
                      {idx !== 1 ? (
                        <span>{part.trim()}</span>
                      ) : (
                        <Emphasize>{part.trim()}</Emphasize>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
              <div className='text-xs xl:text-sm font-light text-white/80 md:pl-0 truncate flex-1 min-w-0'>
                {resource.subtitle}
              </div>
            </div>
            <div className='flex-shrink-0'>
              <DownloadSvg resource={resource} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ResourceList;
